import styled from 'styled-components';
import { theme } from 'styles';

export const RadioLabel = styled.label`
  display: inline-flex;
  cursor: pointer;
  gap: 6px;
`;

export const RadioInput = styled.input`
  position: absolute;
  opacity: 0;
  pointer-events: none;
`;

export const RadioContainer = styled.div`
  width: 20px;
  height: 20px;
  margin: 2px;
  box-shadow: inset 0 0 0 1px ${({ $checked }) => ($checked ? theme.colors.primary600 : theme.colors.darkGray)};
  border-radius: 50%;
  position: relative;

  ${({ $checked }) =>
    $checked &&
    `
    &::before {
      content: '';
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background-color: #009592;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  `}
`;
